export default function TechnologySection() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/8ca44c68a57c2f6a6458a350186cea1b.jpg"
                  alt="기능성 원단"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="relative rounded-xl overflow-hidden shadow-lg mt-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20worker%20wearing%20functional%20protective%20workwear%20industrial%20clothing%20manufacturing%20high%20performance%20fabric%20Korean%20craftsman%20technical%20apparel%20workshop%20professional%20photography%20clean%20simple%20background&width=400&height=500&seq=daygreen-tech-kr-2&orientation=portrait"
                  alt="작업복 제작"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              기술
            </h2>
            
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-50 rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-temp-cold-line text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">초단열</h3>
                  <p className="text-base text-gray-600">에어로젤 코팅 섬유로 극한의 추위에서도 체온을 유지합니다</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-50 rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-feather-line text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">초경량</h3>
                  <p className="text-base text-gray-600">무게 부담 없이 자유로운 움직임을 제공합니다</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-50 rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-shield-star-line text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">고기능성</h3>
                  <p className="text-base text-gray-600">산업 현장의 다양한 환경에 최적화된 보호 기능</p>
                </div>
              </div>
            </div>

            <div className="bg-stone-50 rounded-xl p-8">
              <h4 className="text-lg font-bold text-gray-800 mb-3">제품 라인</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  기능성 워크웨어
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  산업용 보호 의류
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}